window.Page = {

    slider         : document.querySelector('.slider'),
    sliderControls : document.querySelector('.slider-controls'),
    sliderPrev     : document.querySelector('.slider-prev'),
    sliderNext     : document.querySelector('.slider-next'),
    sliderCurrent  : document.querySelector('.slider-current'),
    sliderActive   : document.querySelector('.slide-active'),
    sliderFirst    : document.querySelector('.slide'),
    sliderLast     : document.querySelector('.slide:last-child'),

    productsLinks   : document.querySelectorAll('.vini-navigation-link'),
    productsActive  : document.querySelector('.vini-navigation-link.active'),
    productsCounter : document.querySelector('.vini-counter-current'),

    animationTimeline : null, 

    intro  : document.querySelector('.intro-content'),
    header : document.querySelector('.header'),


    // Let's launch this thing
    liftoff : () => {
        //Page.moveSliderControls()
        Page.advanceSlider()
        Page.retreatSlider()
        Page.scrollAnimations()
        Page.productsGallery()
        Page.swipeOnSlider()

        window.addEventListener('load' , () => {
            // We register the scroll plugin
            gsap.registerPlugin(ScrollTrigger)
            Page.fixTheStickyPosition()
            Page.scrollAnimations()
            Page.resetScrollAnimation()
        })
    },

    // My new function block
    moveSliderControls : () => {
        
        Page.slider.addEventListener('mouseenter' , event => { Page.sliderControls.style.opacity = 1; })
        Page.slider.addEventListener('mouseleave' , event => { Page.sliderControls.style.opacity = 0; })
        Page.slider.addEventListener('mousemove' , event => {
            
            let x = 100 / event.target.clientWidth * event.layerX;
            let y = 100 / event.target.clientHeight * event.layerY;

            Page.sliderControls.style.top = `${y}%`
            Page.sliderControls.style.left = `${x}%`

        })

    },

    advanceSlider : () => {
        Page.sliderNext.addEventListener('click' , () => {
            Page.sliderActive.classList.toggle('slide-active')
            Page.sliderActive = (Page.sliderActive.nextElementSibling) ? Page.sliderActive.nextElementSibling : Page.sliderFirst;
            Page.sliderActive.classList.toggle('slide-active')
        })
    },

    retreatSlider : () => {
        Page.sliderPrev.addEventListener('click' , () => {
            Page.sliderActive.classList.toggle('slide-active')
            Page.sliderActive = (Page.sliderActive.previousElementSibling) ? Page.sliderActive.previousElementSibling : Page.sliderLast;
            Page.sliderActive.classList.toggle('slide-active')
        })
    },

    swipeOnSlider : () => {

        let initialTouch = 0
        let finalTouch   = 0
        let diffTouches  = 0;

        Page.slider.addEventListener('touchstart' , (event) => {
            initialTouch = event.targetTouches[0].screenX
        })

        Page.slider.addEventListener('touchend' , (event) => {
            finalTouch = event.changedTouches[0].screenX
            diffTouches = initialTouch - finalTouch;
            
            if (Math.abs(diffTouches) < 50)
                return;

            if (diffTouches > 0)
                Page.sliderNext.click()

            if (diffTouches < 0)
                Page.sliderPrev.click()

        })

    },

    scrollAnimations : () => {

        let mm = gsap.matchMedia();

        let discScrollTriggerSettings = {
            trigger : ".intro-container",
            start   : "top top",
            end     : "bottom bottom",
            scrub   : true,
            markers : false,
        };

        // Scale the circle up
        gsap.to(".intro-disc-a" , {
            scrollTrigger : discScrollTriggerSettings,
            ease          : "none",
            scale         : "8",
        })

        // Scele the circle up and increase opacity
        gsap.to(".intro-disc-b" , {
            scrollTrigger : discScrollTriggerSettings,
            ease          : "none",
            scale         : "8",
            opacity       : "1",
        })


        let winesScrollTriggerSettings = {
            trigger : ".intro-images",
            start   : "top top",
            end     : "bottom bottom",
            scrub   : true,
            markers : false,
        };

        mm.add("(min-width: 1101px)", () => {

            // Now we do a bunch of fancy animations, maybe they'll work
            gsap.to(".intro-image:nth-child(1)" , {
                scrollTrigger : winesScrollTriggerSettings,
                ease          : "none",
                translateX    : "200%",
            })

            gsap.to(".intro-image:nth-child(2)" , {
                scrollTrigger : winesScrollTriggerSettings,
                ease          : "none",
                translateX    : "100%",
            })

        });


    },

    // Reset and retrigger the sticky scroll when resizes
    resetScrollAnimation : () => {

        window.addEventListener('resize' , () => {

            // Delete all the scroll triggers
            gsap.globalTimeline.clear(); 
            ScrollTrigger.killAll();
            Page.scrollAnimations()
            
        
        })

    },

    productsGallery : () => {
        Page.productsLinks.forEach(link => {

            link.addEventListener('mouseenter' , () => {

                // Do nothing if the link is already active
                if (Page.productsActive == link) return;

                Page.productsActive.classList.remove('active')

                if (document.querySelector('.active-image')) {
                    document.querySelector('.active-image').classList.remove('active-image');
                }
                
                link.classList.add('active')
                Page.productsCounter.innerHTML = link.dataset.index;
                document.getElementById(link.dataset.target).classList.add('active-image')


            })

            link.addEventListener('mouseleave' , () => {

                if (document.querySelector('.active-image')) {
                    document.querySelector('.active-image').classList.remove('active-image');
                }
                
                // Do nothing if the link is already active
                if (Page.productsActive == link) return;

                Page.productsActive.classList.add('active')
                document.querySelector('.intro-image').classList.add('active-image')

                link.classList.remove('active')

                Page.productsCounter.innerHTML = "1";

            })


        })
    },

    fixTheStickyPosition : () => {

        // if the intro content is taller than the viewport we need to fix the sticky position
        if (Page.intro.clientHeight > window.innerHeight) {
            Page.intro.style.top = `calc(100svh - ${Page.intro.clientHeight - Page.header.clientHeight}px)`;
        }

    }

};

Page.liftoff()